import { gql, TypedDocumentNode } from "@apollo/client";

import {
  TemplateQuery,
  TemplateQueryVariables,
} from "./GetTemplate.generated";
import { NOTE_FIELDS } from "../fragments/note";

export const GET_TEMPLATE_BY_UUID: TypedDocumentNode<
  TemplateQuery,
  TemplateQueryVariables
> = gql`
  ${NOTE_FIELDS}
  query template($uuid: String) {
    template(uuid: $uuid) {
      name
      description
      colorScheme
      uuid
      note {
        ...NoteFields
        keyHistory
        keyMedications
        vaccinationStatus
      }
    }
  }
`;
